( function () {
	'use strict';

	function treeListView () {
		var directive = {
			'restrict'     : 'E',
			'templateUrl'  : '/templates/components/evidences/script/tree-list-view.html',
			'controller'   : 'TreeListViewController',
			'controllerAs' : 'vm',
			'scope'        : {
				'view' : '='
			}
		};

		return directive;
	}

	angular.module( 'app.components' )
		.directive( 'treeListView', treeListView );
} )( );
